<div #scrollTop class="h-full overflow-y-auto scroll-smooth bg-gray-200">
  <div class="m-auto max-w-5xl px-3 sm:px-4 md:px-6 mt-6">
    <section class="usdm-card">
      <header class="usdm-hero">
        <div class="usdm-hero-text">
          <span class="usdm-chip">Study Workflow</span>
          <h1 class="usdm-title">USDM Builder</h1>
          <p class="usdm-subtitle">
            Coordinate extraction, generation, and validation of Unified Study Data Model artifacts.
          </p>
        </div>
        @if (currentStep !==1 || isAdmin) {
        <div class="usdm-hero-actions">
          @if (isAdmin) {
          <button type="button" class="usdm-primary-button" (click)="openTrace()">
            <span>Trace</span>
            <i class="pi pi-list text-xs" aria-hidden="true"></i>
          </button>
          }
          @if (currentStep !==1 ) {
          <a [href]="usdm.osbServerUrl" target="_blank">
            <button type="button" class="usdm-primary-button">
              <span>Open in OSB</span>
              <i class="pi pi-external-link text-xs" aria-hidden="true"></i>
            </button>
          </a>
          }
        </div>
        }
      </header>

      <div class="mt-3 sm:mt-6 md:mt-8">
        <p-stepper [value]="currentStep" class="basis-full sm:basis-[40rem] md:basis-[50rem]">
          <p-step-list class="flex-col sm:flex-row text-xs sm:text-sm md:text-base items-start sm:items-center usdm-steps">
            <div class="usdm-steps-rail-full"></div>
            <p-step [value]="1" class="text-lg sm:text-sm md:text-base text-left usdm-step-item">
              <ng-template #content let-activateCallback="activateCallback" let-value="value">
                <div class="usdm-step-button" (click)="goBack(value)"
                  [class.usdm-step-active]="currentStep === value" [class.usdm-step-completed]="isStepCompleted(value)">
                  <div class="usdm-step-icon-wrapper">
                    <div class="usdm-step-icon">
                      <i class="pi pi-file-plus" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="usdm-step-labels">
                    <span class="usdm-step-title">Study Creation</span>
                    <span class="usdm-step-subtitle">Create study & upload protocol</span>
                  </div>
                </div>
              </ng-template>
            </p-step>
            <p-step [value]="2" class="text-lg sm:text-sm md:text-base text-left usdm-step-item" [disabled]="!isStepCompleted(1)">
              <ng-template #content let-activateCallback="activateCallback" let-value="value">
                <div class="usdm-step-button" (click)="goBack(value)"
                [class.usdm-step-active]="currentStep === value" [class.usdm-step-completed]="isStepCompleted(value)">
                  <div class="usdm-step-icon-wrapper">
                    <div class="usdm-step-icon">
                      <i class="pi pi-link" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="usdm-step-labels">
                    <span class="usdm-step-title">Extraction & Mapping</span>
                    <span class="usdm-step-subtitle">Map study data to USDM</span>
                  </div>
                </div>
              </ng-template>
            </p-step>
            <p-step [value]="3" class="text-lg sm:text-sm md:text-base text-left usdm-step-item" [disabled]="!isStepCompleted(2)">
              <ng-template #content let-activateCallback="activateCallback" let-value="value">
                <div class="usdm-step-button" (click)="goBack(value)"
                [class.usdm-step-active]="currentStep === value" [class.usdm-step-completed]="isStepCompleted(value)">
                  <div class="usdm-step-icon-wrapper">
                    <div class="usdm-step-icon">
                      <i class="pi pi-shield" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="usdm-step-labels">
                    <span class="usdm-step-title">Validation</span>
                    <span class="usdm-step-subtitle">Validate & download USDM</span>
                  </div>
                </div>
              </ng-template>
            </p-step>
          </p-step-list>
          <p-step-panels class="p-2 sm:p-4 md:p-6">
            <p-step-panel [value]="1">
              <ng-template #content let-activateCallback="activateCallback">
                <app-study-creation (studyCreationFinished)="completeStep(1); activateCallback(2)" />
              </ng-template>
            </p-step-panel>
            <p-step-panel [value]="2">
              <ng-template #content let-activateCallback="activateCallback">
                <app-extraction-mapping />
                <div class="flex pt-6 justify-between">
                  <p-button label="Back" severity="secondary" icon="pi pi-arrow-left" (onClick)="goBack(1); activateCallback(1)" />
                  <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                    (onClick)="completeStep(2); activateCallback(3); completeStep(3)" />
                </div>
              </ng-template>
            </p-step-panel>
            <p-step-panel [value]="3">
              <ng-template #content let-activateCallback="activateCallback">
                <app-usdm-validation />
                <div class="flex pt-6 justify-start">
                  <p-button label="Back" severity="secondary" icon="pi pi-arrow-left" (onClick)="goBack(2); activateCallback(2)" />
                </div>
              </ng-template>
            </p-step-panel>
          </p-step-panels>
        </p-stepper>
      </div>

      <!-- <section class="usdm-steps">
        <div class="usdm-steps-rail-full"></div>
        <ol class="usdm-steps-list">
          @for (step of steps; track step.id; let i = $index) {
            <li class="usdm-step-item">
              <button
                type="button"
                class="usdm-step-button"
                [class.usdm-step-active]="currentStep === step.id"
                [class.usdm-step-completed]="isStepCompleted(step.id)"
                [class.usdm-step-disabled]="!canVisitStep(step.id)"
                (click)="goToStep(step.id)"
                [disabled]="!canVisitStep(step.id)"
              >
                <div class="usdm-step-icon-wrapper">
                  @if (i < steps.length - 1) {
                    <div class="usdm-step-rail"></div>
                  }
                  <div class="usdm-step-icon">
                    <i [class]="step.icon" aria-hidden="true"></i>
                    
                  </div>
                </div>
                <div class="usdm-step-labels">
                  <span class="usdm-step-title">{{ step.title }}</span>
                  <span class="usdm-step-subtitle">{{ step.subtitle }}</span>
                </div>
              </button>
            </li>
          }
        </ol>
      </section> -->

      <!-- <section class="usdm-content">
        @switch (currentStep) {
          @case (1) {
            <app-study-creation (studyCreationFinished)="handleStudyCreationFinished()" />
          }

          @case (2) {
            <app-extraction-mapping />
            <div class="usdm-nav">
              <button type="button" class="usdm-secondary-button" (click)="goToStep(1)">
                ← Back
              </button>
              <button
                type="button"
                class="usdm-primary-button"
                (click)="completeExtractionAndContinue()"
              >
                Next →
              </button>
            </div>
          }

          @case (3) {
            <app-usdm-validation />
            <div class="usdm-nav usdm-nav-left">
              <button type="button" class="usdm-secondary-button" (click)="goBackFromValidation()">
                ← Back
              </button>
            </div>
          }
        }
      </section> -->
    </section>
  </div>
</div>